import { render, staticRenderFns } from "./Transfer2.vue?vue&type=template&id=16b99728"
import script from "./Transfer2.vue?vue&type=script&lang=js"
export * from "./Transfer2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports